import { render, staticRenderFns } from "./LoadingIndicator.vue?vue&type=template&id=480a7582&"
import script from "./LoadingIndicator.vue?vue&type=script&lang=ts&"
export * from "./LoadingIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports